module.exports = __webpack_public_path__ + "dc8e1dbf2173f2a38f7e0456fa7d9bcb.svg";